import Chart from "react-google-charts";
import React, { Component } from 'react';
import ApiService from '../../service/ApiService';
import { Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../../css/StockCompanyRatings.css';

class StockCompanyRatings extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      origData: [],
      symbol: this.props.symbol
    };
  }

  componentDidMount() {
    ApiService.getCompanyRatings(this.state.symbol)
      .then(result => {
        console.log('Company Ratings', result);
        let filteredData = [];
        filteredData.push(['Label', 'Value']);
        for (var i = 0; i < result.length; i++) {
          let tmpScore = result[i].ratingScore / 5 * 100;
          filteredData.push(['Score', { v: tmpScore, f: '' }]);
        }

        this.setState({ data: filteredData, origData: result });
        console.log('filteredData', filteredData, JSON.stringify(filteredData));
        console.log('data', JSON.stringify(this.state.data));
      })
      .catch((error) => {
        console.log(error);
      });

  }

  render() {
    if (this.state === null) {
      return <div>Loading...</div>
    }
    if (this.state.data === undefined || this.state.data.length <= 0 || this.state.origData === undefined || this.state.origData.length <= 0) {
      return <div>No Data</div>
    }
    return (
      <>
        <Table bordered hover size="xs" style={{ fontSize: "10px" }}>
          <td>
            <Chart
              width={150}
              height={150}
              chartType="Gauge"
              loader={<div>Loading Chart</div>}
              data={this.state.data}
              options={{
                theme: 'maximized',
                redFrom: 0,
                redTo: 30,
                yellowFrom: 30,
                yellowTo: 70,
                greenFrom: 70,
                greenTo: 100,
                majorTicks: ['S. Sell', 'Sell', 'Neutral', 'Buy', 'S. Buy'],
                minorTicks: 5,
                chartArea: { left: 0, top: 0, bottom: 0, right: 0, width: '100%', height: '100%' },
                legend: { position: 'in' },
                titlePosition: 'in',
                axisTitlesPosition: 'in',
              }}
              rootProps={{ 'data-testid': '2' }}
            />
          </td>
          <td>
            <Table bordered hover size="xs" style={{ fontSize: "10px" }}>
              <thead>
                <tr>
                  <th></th>
                  <th>Score (*/5)</th>
                  <th>Recommendation&nbsp;&nbsp;
                    <OverlayTrigger
                      placement="left"
                      overlay={<Tooltip id="button-tooltip-2" style={{ wordBreak: 'break-all' }}>
                        Company Ratings:<br />
                        Discounted Cash Flow(DCF)  ratio: [ 0.3, 0.05, -0.1, -0.3 ]<br />
                        Return On Equity(ROE) ratio: [ 0.3, 0.05, -0.1, -0.3 ]<br />
                        Return On Assets(ROA) ratio: [ 0.3, 0.05, -0.1, -0.3 ]<br />
                        <br/>value &gt;&nbsp;0.3 = "Strong Buy"
                        <br/>0.3&lt;&nbsp;value &nbsp;&gt;0.05 = "Buy"
                        <br/>-0.1&lt;&nbsp;value &nbsp;&gt;0.05 = "Neutral"
                        <br/>-0.3&lt;&nbsp;value &nbsp;&gt;-0.1 = "Sell"
                        <br/>-0.3&lt;&nbsp;value&nbsp; = "Strong Sell"
                      </Tooltip>}>
                      <i style={{ color: '#8A2BE2', fontSize: '15px' }} className={"fa fa-question-circle"}></i>
                    </OverlayTrigger>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr key={10} style={{ fontWeight: 'bold', backgroundColor: 'yellow' }}>
                  <td>Rating</td>
                  <td>{this.state.origData[0].ratingScore}</td>
                  <td>{this.state.origData[0].ratingRecommendation} </td>
                </tr>
                <tr key={20}>
                  <td>DCF</td>
                  <td>{this.state.origData[0].ratingDetailsDCFScore}</td>
                  <td>{this.state.origData[0].ratingDetailsDCFRecommendation} </td>
                </tr>
                <tr key={30}>
                  <td>ROE</td>
                  <td>{this.state.origData[0].ratingDetailsROEScore}</td>
                  <td>{this.state.origData[0].ratingDetailsROERecommendation} </td>
                </tr>
                <tr key={40}>
                  <td>ROA</td>
                  <td>{this.state.origData[0].ratingDetailsROAScore}</td>
                  <td>{this.state.origData[0].ratingDetailsROARecommendation} </td>
                </tr>
                {/* <tr>
                  <td>DE</td>
                  <td>{this.state.origData[0].ratingDetailsDEScore}</td>
                  <td>{this.state.origData[0].ratingDetailsDERecommendation} </td>
                </tr>    
                <tr>
                  <td>PE</td>
                  <td>{this.state.origData[0].ratingDetailsPEScore}</td>
                  <td>{this.state.origData[0].ratingDetailsPERecommendation} </td>
                </tr>
                <tr>
                  <td>PB</td>
                  <td>{this.state.origData[0].ratingDetailsPBScore}</td>
                  <td>{this.state.origData[0].ratingDetailsPBRecommendation} </td>
                </tr>                                             */}
              </tbody>
            </Table>
          </td>
        </Table>
      </>
    )
  }
}

export default StockCompanyRatings;


